//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "email-success",
  props:['email','supplier','phone'],
  methods:{
    againSendEmail(){
      let obj = {
        supplierName:this.supplier,
        email:this.email
      };
      this.$loadingShow();
      this.$post('api/before-login/regist-resend?_allow_anonymous=true',obj).then((data) => {
        this.$vux.toast.text('邮件发送成功');
        this.$loadingHide();
      }).catch((err) =>{
        this.$loadingHide();
      })
    },
    phoneActive(){
      this.$loadingShow();
      this.$get('api/before-login/active-check-phone?_allow_anonymous=true',{phone:this.phone}).then((data) => {
        this.$vux.toast.text('验证码发送成功');
        let queryParam = {checkKey:data.checkKey,phone:data.phone};
        this.$router.push({path:'/supplier/phone-valid',query:queryParam});
        this.$loadingHide();
      }).catch(()=>this.$loadingHide());
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/register/email-success.vue